import React from 'react';
import Icon from '../../../../components/AppIcon';

const AlternativeOptions = () => {
  return (
    <div className="mt-6 p-4 bg-primary-50 rounded-lg border border-primary-200">
      <h3 className="text-sm font-medium text-accent-800 mb-3 flex items-center">
        <Icon name="HelpCircle" size={16} className="mr-2" />
        Need More Help?
      </h3>
      <div className="space-y-2">
        <div className="flex items-center space-x-2">
          <Icon name="Mail" size={14} className="text-accent-500" />
          <span className="text-xs text-accent-600">
            Changed your email?
            <a href="/contact" className="text-primary hover:text-primary-600 font-medium ml-1">
              Contact Support
            </a>
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="MessageCircle" size={14} className="text-accent-500" />
          <span className="text-xs text-accent-600">
            Live chat available 24/7 for urgent issues
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <Icon name="Phone" size={14} className="text-accent-500" />
          <span className="text-xs text-accent-600">
            Call us at 1-800-GIFTSY for immediate assistance
          </span>
        </div>
      </div>
    </div>
  );
};

export default AlternativeOptions;